import { NgModule } from '@angular/core';
import { FeatureStoreStateKey } from 'src/controls/store-keys.enum';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { AuthFeatureState } from '@biz-store/auth/feature.state';
import { reducer as authTokenReducer } from './reducers/auth-token.reducer';
import { reducer as currentUserReducer } from './reducers/current-user.reducer';
import { AuthTokenEffects } from './effects/auth-token.effects';
import { CurrentUserEffects } from './effects/current-user.effects';

import { InvalidTokenEffects } from './effects/invalid-token-effects';
import { SessionExpireDialogModule } from '@biz-ui/containers/session-expire-dialog/session-expire-dialog.module';

@NgModule({
  declarations: [],
  imports: [
    StoreModule.forFeature<AuthFeatureState>(FeatureStoreStateKey.AUTH, {
      currentUser: currentUserReducer,
      tokens: authTokenReducer,
    }),
    EffectsModule.forFeature([
      CurrentUserEffects,
      InvalidTokenEffects,
      AuthTokenEffects,
    ]),
    SessionExpireDialogModule
  ],
})
export class AuthStore {}
